"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Button_1 = __importDefault(require("stremio/components/Button"));
var Image_1 = __importDefault(require("stremio/components/Image"));
var EPG_1 = require("stremio/common/EPG");
var useFormatters_1 = __importDefault(require("../useFormatters"));
var Agenda_less_1 = __importDefault(require("./Agenda.less"));
var renderThumbnailFallback = function () { return react_1.default.createElement(react_2.default, { name: 'tv' }); };
var Agenda = (0, react_1.forwardRef)(function (_a, ref) {
    var programs = _a.programs, now = _a.now, selected = _a.selected, visible = _a.visible, onSelect = _a.onSelect;
    var _b = (0, useFormatters_1.default)(now), time = _b.time, timeRange = _b.timeRange, duration = _b.duration, dayLabel = _b.dayLabel;
    return (react_1.default.createElement("div", { ref: ref, className: Agenda_less_1.default['agenda'], hidden: !visible }, visible ?
        programs.map(function (program, index) {
            var _a, _b, _c;
            var startTime = program.startTime.getTime();
            var endTime = program.endTime.getTime();
            var startsNewDay = index === 0 || (0, EPG_1.epgDateKey)(program.startTime) !== (0, EPG_1.epgDateKey)(programs[index - 1].startTime);
            return (react_1.default.createElement(react_1.default.Fragment, { key: (_a = program.id) !== null && _a !== void 0 ? _a : startTime },
                startsNewDay ?
                    react_1.default.createElement("div", { className: Agenda_less_1.default['day'] }, dayLabel(program.startTime))
                    :
                        null,
                react_1.default.createElement(Button_1.default, { role: 'button', className: Agenda_less_1.default['program'], "aria-pressed": program === selected, "aria-current": startTime <= now && now < endTime ? 'true' : undefined, "aria-label": "".concat(program.title, " \u00B7 ").concat(timeRange(program), " \u00B7 ").concat(duration(program)), onClick: function () { return onSelect(program); } },
                    react_1.default.createElement("div", { className: Agenda_less_1.default['time'] },
                        react_1.default.createElement("div", null, time(program.startTime)),
                        react_1.default.createElement("div", null, time(program.endTime))),
                    react_1.default.createElement("div", { className: Agenda_less_1.default['thumbnail'] },
                        react_1.default.createElement(Image_1.default, { src: (_c = (_b = program.thumbnail) !== null && _b !== void 0 ? _b : program.channelLogo) !== null && _c !== void 0 ? _c : '', alt: '', renderFallback: renderThumbnailFallback })),
                    react_1.default.createElement("div", { className: Agenda_less_1.default['title'] }, program.title),
                    react_1.default.createElement("div", { className: Agenda_less_1.default['duration'] }, duration(program)))));
        })
        :
            null));
});
Agenda.displayName = 'Agenda';
exports.default = Agenda;
